import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, message, Spin, Col } from 'antd';
import { fetchProfile } from "../components/Profile";
import { useNavigate } from "react-router-dom";
import { baseBackendUrl } from "../shared/constants";
import MarkdownRenderer from "../components/MarkdownRenderer";
import "./css/welcome.css";
import { fetchContent, resendVerification, verifyEmail } from "../components/Welcome";

const Welcome = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [isVerifying, setIsVerifying] = useState(false);
    const [blocks, setBlocks] = useState([]);
    document.title = "Code.ak";

    useEffect(() => {
        document.title = "Code.ak";
        async function loadProfile() {
            try {
                await fetchProfile(token);
            } catch (error) {
                localStorage.removeItem('token');
                navigate("/login");
            }
        }
        const fetchData = async () => {
            try {
                const contentData = await fetchContent();
                const parsed = JSON.parse(contentData.content);
                setBlocks(parsed);
            } catch (error) {
                console.error("Ошибка загрузки контента:", error);
            }
        };
        const checkEmailVerification = async () => {
            if (!token) return;
            try {
                const userData = await fetchProfile(token);
                if (!userData.email_verified) {
                    setUserEmail(userData.email);
                    setIsModalOpen(true);
                }
            } catch (error) {
                console.error("Ошибка получения профиля:", error);
            }
        };

        if (token) {
            loadProfile();
        }
        checkEmailVerification();
        fetchData();
        setLoading(false);
    }, [token, navigate]);

    const handleResendVerification = async () => {
        try {
            await resendVerification(userEmail);
            message.success("Письмо отправлено повторно");
        } catch (error) {
            message.error("Ошибка отправки письма");
        }
    };

    const handleVerifyCode = async () => {
        if (!verificationCode) {
            message.error("Введите код подтверждения");
            return;
        }
        setIsVerifying(true);
        try {
            await verifyEmail(userEmail, verificationCode);
            setIsModalOpen(false);
            window.location.reload();
        } catch (error) {
            message.error(error.message);
        } finally {
            setIsVerifying(false);
        }
    };

    if (loading) {
        return <Spin size="large" style={{ display: 'block', margin: '50px auto' }} />;
    }
    document.title = "Code.ak";
    return (
        <div>
            <div>
                <Col span={24}>
                    {blocks.map((block) => {
                        if (block.type === 'text') {
                            return (
                                <div key={block.id} className="block-text" style={{ marginBottom: 32 }}>
                                    {block.title && <h2>{block.title}</h2>}
                                    <MarkdownRenderer content={block.content} />
                                </div>
                            );
                        }
                        if (block.type === 'image') {
                            return (
                                <div key={block.id} className="block-image" style={{ textAlign: 'center', marginBottom: 32 }}>
                                    <img
                                        src={`${baseBackendUrl}${block.imageUrl}`}
                                        alt={block.caption || 'Изображение'}
                                        style={{ maxWidth: '100%', borderRadius: 8 }}
                                    />
                                    {block.caption && <p style={{ marginTop: 8, color: '#888' }}>{block.caption}</p>}
                                </div>
                            );
                        }
                        return null;
                    })}
                </Col>
            </div>

            <Modal
                title="Подтверждение Email"
                open={isModalOpen}
                footer={[
                    <Button key="resend" type="primary" onClick={handleResendVerification}>
                        Отправить письмо
                    </Button>,
                    <Button key="verify" type="primary" loading={isVerifying} onClick={handleVerifyCode}>
                        Подтвердить
                    </Button>,
                ]}
                onCancel={() => setIsModalOpen(false)}
            >
                <p>Ваш email <strong>{userEmail}</strong> не подтверждён.</p>
                <p>Введите код, который мы отправили на вашу почту:</p>
                <Input
                    placeholder="Введите код"
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                    maxLength={6}
                />
            </Modal>
        </div>
    );
};

setTimeout(() => {
    document.title = "Code.ak";
}, 1);

export default Welcome;
